import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';
import { SidenavService } from 'src/app/modules/shared/services/sidenav.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { AlertMessageService } from 'src/app/modules/shared/services/alertmessage.service';
import { ScrollControlService } from 'src/app/modules/shared/services/scroll-control.service';
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { AuthGuard } from 'src/app/modules/shared/services/auth.guard';
import { ApiEstimativaService } from 'src/app/modules/shared/services/api-estimativa.service';
import { TechnologiesManagementService } from 'src/app/modules/shared/services/technologiesManagement.service';
import { Subject } from 'rxjs';
import { filter, switchMap, take, takeUntil } from 'rxjs/operators';
import { Permission } from 'src/app/modules/shared/security/permission';
import { EstimationState } from 'src/app/models/EstimationState';

@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {

  Permission = Permission;
  EstimationState = EstimationState;

  variables: any;
  private readonly destroy$ = new Subject<void>();

  isOpen: boolean = false;
  userName: any;
  shouldPinSidenav: boolean = false;
  projects: any[] = [];
  emcurso = 0;
  certified = 0;
  concluidas = 0;
  techCount = 0;
  alertMessage: any;
  router: any;

  constructor(
    public authService: AuthService,
    private projectsService: ProjectsService,
    private sidenavService: SidenavService,
    private dataService: DataService,
    private languageService: LanguageService,
    private usersManagementService: UsersManagementService,
    private AlertMessageService: AlertMessageService,
    private technologiesManagementService: TechnologiesManagementService,
    private apiEstimativaService: ApiEstimativaService,
    private elRef: ElementRef,
    private scrollService: ScrollControlService
  ) {
  }
  @ViewChildren('news') newsElements!: QueryList<ElementRef>;

  ngAfterViewInit(): void {

    this.newsElements.changes.subscribe(() => {
      this.adjustScrolling();
    });
    this.adjustScrolling(); // Call initially in case changes do not trigger
  }

  adjustScrolling(): void {
    const holder = this.elRef.nativeElement.querySelector('.holder');
    const inner = this.elRef.nativeElement.querySelector('.inner');

    const newsElements = this.newsElements.toArray().map(elem => elem.nativeElement);


    if (newsElements.length > 1) {
      const newsWidth = newsElements[0].offsetWidth;
      const holderWidth = holder.offsetWidth;

      // Calculate the padding or margin, ensuring a minimum padding of 10px
      const paddingRight = Math.max(holderWidth - newsWidth, 150);

      newsElements.forEach(element => {
        element.style.paddingRight = `${paddingRight}px`;
      });

      // Adjust the inner width to accommodate both news divs plus padding
      inner.style.width = `${newsWidth * 2 + paddingRight * 2}px`;
    }
  }

  ngOnInit(): void {

    this.authService.userDataLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this.authService.getUserData().pipe(take(1)))
    ).subscribe(data => {

      this.projectsService.getProjects().subscribe(response => {
        this.projects = response;
      });

      if (!(data.role === "USER") && !(data.role === "ARCHITECT"))
        this.technologiesManagementService.getAllTechnologies().subscribe(data => {
          this.techCount = data.length
        });

      this.apiEstimativaService.myEstimates().subscribe(data => {
        data.forEach((estimate: any) => {
          if (estimate?.state === EstimationState.INCOMPLETE)
            this.emcurso++;
          else if (estimate?.state === EstimationState.CERTIFIED) {
            this.certified++
          }
          else if (estimate?.state === EstimationState.COMPLETE) {
            this.concluidas++
          }
        })
      });
    });

    this.scrollService.setScroll(true);

    this.languageService.translations$
      .pipe(takeUntil(this.destroy$))
      .subscribe((vars: any) => {
        this.variables = vars;
      });

    // to emit alerts
    // this.AlertMessageService.getAlertMessage().subscribe(message => {
    //   if (message) {
    //     this.alertMessage = message;
    //   }
    // });

    this.dataService.setEstimate({});
    this.userName = this.authService.returnUserName();
  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
